// extracted by mini-css-extract-plugin
export default {"projectCard":"projectCard_projectCard__Br8px"};